import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { solicitudDetalleService } from '../../services';

const SeccionDeclaraciones = ({ solicitudId, tipo }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    // Campos para Individuo
    esPep: false,
    motivoPep: '',
    // Campos comunes
    esFATCA: false,
    motivoFatca: '',
    declaraUIF: false,
    motivoUIF: ''
  });

  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const getMethod = tipo === 'individuo'
        ? solicitudDetalleService.getDeclaracionesIndividuo
        : solicitudDetalleService.getDeclaracionesEmpresa;
      const response = await getMethod(solicitudId);
      if (response) {
        if (tipo === 'individuo') {
          setFormData({
            esPep: response.esPep || false,
            motivoPep: response.motivoPep || '',
            esFATCA: response.esFATCA || false,
            motivoFatca: response.motivoFatca || '',
            declaraUIF: response.declaraUIF || false,
            motivoUIF: response.motivoUIF || ''
          });
        } else {
          // Empresa
          setFormData({
            esPep: false,
            motivoPep: '',
            esFATCA: response.esFATCA || false,
            motivoFatca: response.motivoFatca || '',
            declaraUIF: response.declaraUIF || false,
            motivoUIF: response.motivoUIF || ''
          });
        }
      }
    } catch (err) {
      setError('Error al cargar las declaraciones');
    } finally {
      setLoading(false);
    }
  }, [solicitudId, tipo]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      let datosParaGuardar;
      if (tipo === 'individuo') {
        datosParaGuardar = {
          solicitudId: parseInt(solicitudId),
          esPep: formData.esPep,
          motivoPep: formData.motivoPep,
          esFATCA: formData.esFATCA,
          motivoFatca: formData.motivoFatca,
          declaraUIF: formData.declaraUIF,
          motivoUIF: formData.motivoUIF
        };
      } else {
        // Empresa
        datosParaGuardar = {
          solicitudId: parseInt(solicitudId),
          esFATCA: formData.esFATCA,
          motivoFatca: formData.motivoFatca,
          declaraUIF: formData.declaraUIF,
          motivoUIF: formData.motivoUIF
        };
      }
      const saveMethod = tipo === 'individuo'
        ? solicitudDetalleService.saveDeclaracionesIndividuo
        : solicitudDetalleService.saveDeclaracionesEmpresa;
      await saveMethod(datosParaGuardar);
      setSuccess('Datos guardados exitosamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Declaraciones
        </Typography>
        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}
        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {tipo === 'individuo' && (
              <>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.esPep}
                        onChange={(e) => handleInputChange('esPep', e.target.checked)}
                      />
                    }
                    label="Es PEP (Persona Expuesta Políticamente)"
                  />
                </Grid>
                {formData.esPep && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Motivo PEP"
                      multiline
                      rows={3}
                      value={formData.motivoPep}
                      onChange={(e) => handleInputChange('motivoPep', e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                )}
              </>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.esFATCA}
                    onChange={(e) => handleInputChange('esFATCA', e.target.checked)}
                  />
                }
                label="Es FATCA"
              />
            </Grid>
            {formData.esFATCA && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Motivo FATCA"
                  multiline
                  rows={3}
                  value={formData.motivoFatca}
                  onChange={(e) => handleInputChange('motivoFatca', e.target.value)}
                  variant="outlined"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.declaraUIF}
                    onChange={(e) => handleInputChange('declaraUIF', e.target.checked)}
                  />
                }
                label="Declara UIF"
              />
            </Grid>
            {formData.declaraUIF && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Motivo UIF"
                  multiline
                  rows={3}
                  value={formData.motivoUIF}
                  onChange={(e) => handleInputChange('motivoUIF', e.target.value)}
                  variant="outlined"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} /> : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default SeccionDeclaraciones;

